import { PUBLIC_PAGE_API_ENDPOINT } from "../../../constants"
import { getAntiforgeryToken } from "../../../utils/antiforgery"

export const postAccountForm = async (
	endpoint: string,
	antiForgeryToken: string,
	data: Record<string, string>,
	method: string
) => {
	const url = PUBLIC_PAGE_API_ENDPOINT + endpoint
	const body = Object.keys(data)
		.map((key) => key + "=" + data[key])
		.join("&")

	var antiforgeryToken = await getAntiforgeryToken()

	return fetch(url, {
		method: method,
		body,
		headers: {
			RequestVerificationToken: antiforgeryToken,
			Accept: "application/json",
			"Content-Type": "application/x-www-form-urlencoded",
		},
	}).then((res) => {
		return res.json().then((json) => ({
			success: res.status === 200,
			data: json,
			statusCode: res.status,
		}))
	})
}
